import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const headers = { headers: { Authorization: `Bearer ${localStorage.userToken}`, 'Content-Type': 'application/json' } }
const url = 'https://api-learn.x-cloud.info/api/manager/'

export const requestGetAll = createAsyncThunk('exemptions/requestGetAll', async () => {
  const response = await axios.post(url + 'exemptions/getAll', null, headers)
  return response.data.data
})

export const requestAdd = createAsyncThunk('exemptions/requestAdd', async (data, { getState }) => {
  const response = await axios.post(url + 'exemptions/add', data, headers)
  const result = getState().exemptionsReducer.tableInfo.slice()
  result.unshift(response.data.data)
  return result
})

export const requestUpdate = createAsyncThunk('exemptions/requestUpdate', async (data, { getState }) => {
  await axios.post(url + 'exemptions/update', data, headers)
  const result = getState().exemptionsReducer.tableInfo.slice()
  const currentEdit = result.indexOf(result.find(child => child.id === Number(data.id)))
  result[currentEdit] = data
  return result
})

export const requestDelete = createAsyncThunk('exemptions/requestDelete', async (data, { getState }) => {
  await axios.post(url + 'exemptions/delete', data, headers)
  const result = getState().exemptionsReducer.tableInfo.slice()
  const indexDelete = result.indexOf(result.find(child => child.id === Number(data.id)))
  result.splice(indexDelete, 1)
  return result
})

export const requestGetOne = createAsyncThunk('exemptions/requestGetOne', async data => {
  const response = await axios.post(url + 'exemptions/getOne', { id: data.id }, headers)
  data.getOne(response.data.data)
})

const exemptions = createSlice({
  name: 'exemptions',
  initialState: {
    tableInfo: null,
  },

  extraReducers: {
    [requestGetAll.fulfilled]: (state, action) => {
      state.tableInfo = action.payload
    },
    [requestAdd.fulfilled]: (state, action) => {
      state.tableInfo = action.payload
    },
    [requestUpdate.fulfilled]: (state, action) => {
      state.tableInfo = action.payload
    },
    [requestDelete.fulfilled]: (state, action) => {
      state.tableInfo = action.payload
    },
  },
})

export default exemptions.reducer
